<form class="d-flex flex-column gap-6 w-100" [formGroup]="reassignmentForm" novalidate>
  <div class="d-flex align-items-center gap-6">
    <div class="form-group w-50">
      @let firstNameControl = reassignmentForm.controls.firstName;
      <label class="form-label" for="firstName">First Name</label>
      <input type="text" name="firstName" placeholder="John" [ngClass]="{ 'form-input--invalid': firstNameControl.touched && firstNameControl.errors }" formControlName="firstName" id="firstName" class="form-input" [dataSelector]="dataSelector + '-first-name-input'" />
      <app-input-error-hint [control]="firstNameControl" />
    </div>
    <div class="form-group w-50">
      @let lastNameControl = reassignmentForm.controls.lastName;
      <label class="form-label" for="lastName">Last Name</label>
      <input type="text" name="lastName" placeholder="Doe" [ngClass]="{ 'form-input--invalid': lastNameControl.touched && lastNameControl.errors }" formControlName="lastName" id="lastName" class="form-input" [dataSelector]="dataSelector + '-last-name-input'" />
      <app-input-error-hint [control]="lastNameControl" />
    </div>
  </div>
  <div class="form-group">
    @let emailControl = reassignmentForm.controls.email;
    <label class="form-label" for="email">Email</label>
    <input type="email" name="email" placeholder="Enter email address" [ngClass]="{ 'form-input--invalid': emailControl.touched && emailControl.errors }" formControlName="email" id="email" class="form-input" [dataSelector]="dataSelector + '-email-input'" />
    <app-input-error-hint [control]="emailControl" />
  </div>
  <div class="form-group">
    @let subjectControl = reassignmentForm.controls.subject;
    <label class="form-label" for="subject">Subject</label>
    <input type="text" name="subject" placeholder="Enter subject" [ngClass]="{ 'form-input--invalid': subjectControl.touched && subjectControl.errors }" formControlName="subject" id="subject" class="form-input" [dataSelector]="dataSelector + '-subject-input'" />
    <app-input-error-hint [control]="subjectControl" />
  </div>
  <div class="form-group">
    <label class="form-label" for="message">Message (optional)</label>
    <textarea formControlName="message" id="message" placeholder="Enter message" class="form-input" [dataSelector]="dataSelector + '-message-textarea'"></textarea>
  </div>
</form>
